import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';

import Chip from '@features/filter/Chip';
import {
	MIX_PANEL_EVENTS,
	PROJECT_DETAILS_TABLE_COLUMNS
} from '@features/project-management-tools/constents';
import { setSelectedColumnToHide } from '@features/project-management-tools/redux/myProjectDetailsSlice';
import { useHideColumnMutation } from '@features/project-management-tools/api/projectManagementApi';
import { getOwnerList, getStatusList } from '@features/project-management-tools/utils';

import { getUserInfo } from '@/utils/Util';
import { useMyProjectDetails } from '@/store/reducers';
import CommonImage from '@/components/CommonImage';
import { useMixPanelTrakingEventMutation } from '@/api/commonApis';

const FilterTask = ({ id, setShowFilter, showFilter }) => {
	const { selectedColumnToHide } = useMyProjectDetails();
	const [isShowColumnFilterDropdown, setIsShowColumnFilterDropdown] = useState(false);
	const [ownerList, setOwnerList] = useState([]);
	const [statusList, setStatusList] = useState([]);

	const dispatch = useDispatch();

	const { taskList } = useMyProjectDetails();

	const dropdownRef = useRef(null);
	const userId = getUserInfo()?.id;

	const [mixPanelTrakingEvent] = useMixPanelTrakingEventMutation();
	const [hideColumn] = useHideColumnMutation();

	useEffect(() => {
		setOwnerList(getOwnerList(taskList));
		setStatusList(getStatusList(taskList));
	}, [taskList]);

	const handleColumnSelection = (columnId) => {
		let updatedColumns;
		if (selectedColumnToHide.includes(columnId)) {
			updatedColumns = selectedColumnToHide.filter((id) => id !== columnId);
		} else {
			updatedColumns = [...selectedColumnToHide, columnId];
		}
		dispatch(setSelectedColumnToHide(updatedColumns));

		const requestBody = {
			userId: userId,
			columnVisibilityJson: JSON.stringify(updatedColumns),
			applyToAllUsers: false
		};

		const mixPanelBody = updatedColumns?.map((col) => ({
			columnName: col,
			isHide: true
		}));

		hideColumn({ params: requestBody, projectId: id });

		mixPanelTrakingEvent({
			type: MIX_PANEL_EVENTS.PROJECT_TASK_COLUMN_VISIBILITY_ON_CHANGE,
			body: mixPanelBody
		});
	};

	useEffect(() => {
		dispatch({
			type: 'STORE_DEPENDENT_FILTER_LIST',
			payload: {
				responseData: { statusList: statusList, ownerList: ownerList },
				filterListPage: 'PROJECT_DETAILS'
			}
		});
	}, [showFilter]);

	useEffect(() => {
		if (!isShowColumnFilterDropdown) return;

		const handleClickOutside = (event) => {
			if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
				setIsShowColumnFilterDropdown(false);
			}
		};

		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [isShowColumnFilterDropdown]);

	return (
		<div className="table-kanban-filter-actions">
			<div className="filter-container-top filter-container-top-v2 bg-white justify-content-start px-0">
				<div className="filters d-block">
					<div
						className="filter-toggle"
						onClick={() => {
							// mixPanelTrakingEvent({
							// 	type: MIX_PANEL_EVENTS.PROJECT_TASK_LIST_FILTER,
							// 	body: {
							// 		showFilter: showFilter
							// 	}
							// });
							setShowFilter((prev) => !prev);
							setIsShowColumnFilterDropdown(false);
						}}
					>
						<CommonImage alt="filter" src="/icons/filter24.svg" />
						<CommonImage alt="filter" className="d-none" src=" /icons/filter-close.svg" />
						<span className="regular-14 gray_dark_02">Filter</span>
					</div>
				</div>

				{/*Filter Actions*/}
				<div className="column-hide-show-dropdown">
					<div className="dropdown" ref={dropdownRef}>
						<button
							className="btn btn-default dropdown-toggle regular-14 gray_dark_02"
							type="button"
							onClick={() => {
								setIsShowColumnFilterDropdown((prev) => !prev);
								setShowFilter(false);
							}}
						>
							Column
						</button>
						<ul
							className={`dropdown-menu  shadow-lg ${isShowColumnFilterDropdown ? 'show' : 'd-none'}`}
						>
							<li>
								<div className="d-flex align-items-center justify-content-between px-3 py-2">
									<p className="regular-14 gray_dark_01 weight-600">Show and hide column</p>
								</div>
							</li>

							{PROJECT_DETAILS_TABLE_COLUMNS.map((column) => (
								<li className="px-4 pb-3 pt-3" key={column?.id}>
									<div className="custom-chekbox gray-checkbox px-3">
										<div className="form-group mb-0">
											<input
												type="checkbox"
												id={column?.id}
												name={column?.name}
												value={column?.name}
												onChange={() => handleColumnSelection(column?.id)}
												checked={!selectedColumnToHide.includes(column?.id)}
											/>
											<label
												className="regular-14 d-flex align-items-center"
												htmlFor={column?.id}
											>
												<span className="pl-1">{column?.name}</span>
											</label>
										</div>
									</div>
								</li>
							))}
						</ul>
					</div>
				</div>
				<div className="chip-container d-flex align-items-center flex-wrap px-4 pb-2">
					<div className="chips d-flex align-items-center flex-wrap">
						<Chip parentComponent="FAVOURITE_DETAILS" />
					</div>
				</div>
			</div>
		</div>
	);
};

export default FilterTask;
